import { type FC } from 'react'
import { DELTA_TRIAL_FEATURES } from '../../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../../Plan/DeltaTrial/Upsell/Upsell'

export const CrossClientUpsell: FC = () => {
  return <Upsell feature={DELTA_TRIAL_FEATURES['clientQueries']} />
}
